const NDAView = ({ supplier }) => {
  return (
    <div className="card">
      <h5>NDA</h5>

      <div className="mt-2 space-y-1">
        {supplier.signedNdaFileUrl ? (
          <a
            href={supplier.signedNdaFileUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {supplier.signedNdaFileUrl}
          </a>
        ) : (
          "No NDA signed."
        )}
      </div>
    </div>
  );
};

export default NDAView;
